export const inventory = {
  choose_grains: [
    { box_no: 1, item_name: "Rice" },
    { box_no: 2, item_name: "Lentil" },
    { box_no: 3, item_name: "Sugar" },
    { box_no: 4, item_name: "Carrot" },
  ],
  choose_spices: [
    { box_no: 1, item_name: "Haldi" },
    { box_no: 2, item_name: "Salt" },
  ],
  choose_oil: [
    { box_no: 1, item_name: "Olive Oil" },
    { box_no: 2, item_name: "Mustartd Oil" },
  ],
  choose_paste: [
    { box_no: 1, item_name: "Tomato Sause" },
    { box_no: 2, item_name: "Ginger Garlic Paste" },
    { box_no: 3, item_name: "Soya Sause" },
  ],
  choose_stir: [
    { box_no: 1, item_name: "Normal Stir", speed: 2 },
    { box_no: 2, item_name: "Slow Stir", speed: 1 },
  ],
  manual_bowl: [
    { box_no: 1, item_name: "Bowl", speed: 2 },
    { box_no: 2, item_name: "Slow Stir", speed: 1 },
  ],
};

export const servingPersons = [
  { name: "1 Person", value: 1 },
  { name: "2 Person", value: 2 },
  { name: "3 Person", value: 3 },
  { name: "4 Person", value: 4 },
  { name: "5 Person", value: 5 },
  { name: "6 Person", value: 6 },
];
